let VueTitle = { 
    install: function (Vue) {
        let prop = {
            get: function () { return document.title },
            set: function (v) { document.title = v + ` - ${window.app.app_name}` }
        };

        Object.defineProperty(Vue, 'pageTitle', prop);
        Object.defineProperty(Vue.prototype, '$pageTitle', prop);
    }
};

export default VueTitle;